<mat-card-title class="h5">
	Child Information
</mat-card-title>
<mat-divider> </mat-divider>

<div class="padding-vertical-md">
	<form [formGroup]="form" (ngSubmit)="submit()" #childInfoForm="ngForm">
		<div class="row">

			<mat-form-field class="col-lg-3">
				<mat-label>
					Child's Last Name
				</mat-label>
				<input matInput id="lastName" name="lastName" type="string" formControlName="lastName" />
			</mat-form-field>

			<mat-form-field class="col-lg-3">
				<mat-label>
					Second Last Name
				</mat-label>
				<input matInput id="secondLastName" name="secondLastName" type="string"
					formControlName="secondLastName" />
			</mat-form-field>

			<mat-form-field class="col-lg-3">
				<mat-label>
					Child's First Name
				</mat-label>
				<input matInput id="firstName" name="firstName" type="string" formControlName="firstName" />
			</mat-form-field>

			<mat-form-field class="col-lg-3">
				<mat-label>
					Middle Name
				</mat-label>
				<input matInput id="middleName" name="middleName" type="string" formControlName="middleName" />
			</mat-form-field>
		</div>

		<div class="row">
			<mat-form-field class="col-lg-4">
				<mat-label>
					Suffix
				</mat-label>
				<mat-select formControlName="suffix">
					<mat-option *ngFor="let suffix of suffixes" [value]="suffix.value">
						{{suffix.display}}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field class="col-lg-4">
				<mat-label>
					Gender
				</mat-label>
				<mat-select formControlName="gender">
					<mat-option *ngFor="let gender of genders" [value]="gender.value">
						{{gender.display}}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field class="col-lg-4">
				<mat-label>
					Date of Birth
				</mat-label>
				<input matInput formControlName="dob" [matDatepicker]="dobPicker" (click)="dobPicker.open()">
				<mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
				<mat-datepicker #dobPicker></mat-datepicker>
			</mat-form-field>
		</div>

		<div class="row">
			<mat-form-field class="col-lg-4">
				<mat-label>
					Race
				</mat-label>
				<mat-select formControlName="race" multiple>
					<mat-option *ngFor="let race of races" [value]="race.value">
						{{race.display}}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field class="col-lg-4">
				<mat-label>
					Birth Verification
				</mat-label>
				<mat-select formControlName="birthVerification">
					<mat-option *ngFor="let birthVerification of birthVerifications" [value]="birthVerification.value">
						{{birthVerification.display}}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field class="col-lg-4">
				<mat-label>
					Medical Alert
				</mat-label>
				<mat-select formControlName="medicalAlert">
					<mat-option *ngFor="let medicalAlert of medicalAlerts" [value]="medicalAlert.value">
						{{medicalAlert.display}}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="row" *ngIf="!isLoading">
			<input-city-autocomplete class="col-lg-4" [id]="'Birth City'" [name]="'Birth City'" [label]="'Birth City'"
				[placeholder]="'Birth City'" [(selectedCity)]="birthCity" [(state)]="birthState" [required]="true"
				[disabled]="!editing">
			</input-city-autocomplete>

			<input-state-autocomplete class="col-lg-4" [id]="'Birth State'" [name]="'Birth State'"
				[label]="'Birth State'" [placeholder]="'Birth State'" [(selectedState)]="birthState"
				[(country)]="birthCountry" [required]="true" [disabled]="!editing">
			</input-state-autocomplete>

			<input-country-autocomplete class="col-lg-4" [id]="'Birth Country'" [name]="'Birth Country'"
				[label]="'Birth Country'" [placeholder]="'Birth Country'" [(selectedCountry)]="birthCountry"
				[required]="true" [disabled]="!editing">
			</input-country-autocomplete>
		</div>

		<div class="row" *ngIf="isLoading">
			<mat-form-field class="col-lg-4">
				<mat-label>
					Birth City
				</mat-label>
				<input matInput disabled>
				<button mat-icon-button matSuffix tabindex="-1">
					<mat-icon mat-icon-button>
						<mat-spinner diameter="18"></mat-spinner>
					</mat-icon>
				</button>
			</mat-form-field>
			<mat-form-field class="col-lg-4">
				<mat-label>
					Birth State
				</mat-label>
				<input matInput disabled>
				<button mat-icon-button matSuffix tabindex="-1">
					<mat-icon mat-icon-button>
						<mat-spinner diameter="18"></mat-spinner>
					</mat-icon>
				</button>
			</mat-form-field>
			<mat-form-field class="col-lg-4">
				<mat-label>
					Birth Country
				</mat-label>
				<input matInput disabled>
				<button mat-icon-button matSuffix tabindex="-1">
					<mat-icon mat-icon-button>
						<mat-spinner diameter="18"></mat-spinner>
					</mat-icon>
				</button>
			</mat-form-field>
		</div>

		<div class="row">
			<div class="col-lg-6">
				<mat-checkbox [color]="'primary'" class="checkbox-margin" formControlName="latino">
					Latino
				</mat-checkbox>
			</div>
			<div class="col-lg-6">
				<mat-checkbox [color]="'primary'" class="checkbox-margin" formControlName="multiBirth">
					Multi Birth
				</mat-checkbox>
			</div>
		</div>

		<div class="row">
			<mat-form-field class="col-lg-4">
				<mat-label>
					Preferred Phone Number
				</mat-label>
				<input matInput id="preferredPhoneNumber" name="preferredPhoneNumber" type="string"
					placeholder="123-456-7890" formControlName="preferredPhoneNumber" telephoneValidator />
			</mat-form-field>
			<mat-form-field class="col-lg-8">
				<mat-label>
					Preferred Email
				</mat-label>
				<input matInput id="preferredEmail" name="preferredEmail" type="string" placeholder="email@domain.com"
					formControlName="preferredEmail" />
			</mat-form-field>

		</div>
	</form>

	<tracking-history *ngIf="!isLoading" [formName]="'Student Demographics'"
		[formID]="studentId ? studentId.toString() : ''"></tracking-history>
</div>